// ARIA Live Region for accessibility announcements
// This utility helps screen readers announce important messages

class AriaLive {
    constructor() {
        this.liveRegion = null;
        this.init();
    }
    
    init() {
        // Create live region if it doesn't exist
        if (!document.getElementById('aria-live-region')) {
            this.liveRegion = document.createElement('div');
            this.liveRegion.id = 'aria-live-region';
            this.liveRegion.setAttribute('aria-live', 'polite');
            this.liveRegion.setAttribute('aria-atomic', 'true');
            this.liveRegion.style.position = 'absolute';
            this.liveRegion.style.left = '-10000px';
            this.liveRegion.style.width = '1px';
            this.liveRegion.style.height = '1px';
            this.liveRegion.style.overflow = 'hidden';
            document.body.appendChild(this.liveRegion);
        } else {
            this.liveRegion = document.getElementById('aria-live-region');
        }
    }
    
    announce(message, priority = 'polite') {
        if (!this.liveRegion) {
            this.init();
        }
        
        // Clear previous message
        this.liveRegion.textContent = '';
        
        // Set priority
        this.liveRegion.setAttribute('aria-live', priority);
        
        // Announce new message after a brief delay for better screen reader support
        setTimeout(() => {
            this.liveRegion.textContent = message;
        }, 100);
    }
    
    announceFormErrors(errors) {
        const errorCount = errors.length;
        if (errorCount === 0) return;
        
        const message = errorCount === 1 
            ? `There is 1 error in the form. ${errors[0]}`
            : `There are ${errorCount} errors in the form. First error: ${errors[0]}`;
            
        this.announce(message, 'assertive');
    }
}

// Create singleton instance
const ariaLive = new AriaLive();

// Export for use in other modules
export default ariaLive;